export default __webpack_public_path__ + "static/media/yocket.76b7d60a.png";